import "./fourthsection.css";
function FourthSection({ sections }) {
  return (
    <section className="position-after-3 second" id="skills">
      <div className="section">
        <div className="outer background-white second">
          <div className="contentd">
            <h2>Skills</h2>
            <div className="skill-grid">
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
                alt="JS"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original-wordmark.svg"
                alt="java"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg"
                alt="c"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg"
                alt="c++"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg"
                alt="react"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg"
                alt="redux"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original-wordmark.svg"
                alt="psql"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original-wordmark.svg"
                alt="express"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original-wordmark.svg"
                alt="flask"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
                alt="python"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/socketio/socketio-original-wordmark.svg"
                alt="socketIo"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlalchemy/sqlalchemy-original-wordmark.svg"
                alt="sqlalchemy"
                className="devicon"
              />
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original-wordmark.svg"
                alt="git"
                className="devicon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FourthSection;
